<template>
  <div class="card p-shadow-app p-p-4">
    <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
      <h2 class="p-m-0">Entidades</h2>
    </div>

    <div style="height: 65vh">
      <DataTable
        :value="entities"
        :filters.sync="filters"
        :loading="loading"
        responsiveLayout="scroll"
        filterDisplay="row"
        class="p-datatable-sm"
        scrollable
        scrollHeight="flex"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 20, 50, 100]"
        :lazy="true"
        :totalRecords="totalRecords"
        @filter="fetchEntities"
        @page="fetchEntities"
      >
        <template #header>
          <div>
            <Button
              icon="pi pi-plus"
              @click="createEntity()"
              v-if="can('seeEntities')"
            />
          </div>
        </template>
        <template #empty> Nenhuma entidade encontrada. </template>
        <template #loading> A carregar... </template>
        <Column field="name" header="Nome" filterField="name">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column field="nif" header="Contribuinte" filterField="nif">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column field="address" header="Morada" filterField="address">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="zip_code"
          header="Código Postal"
          filterField="zip_code"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column field="telephone" header="Telefone" filterField="telephone">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column field="tlmvl" header="Telemóvel" filterField="tlmvl">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column field="email" header="Email" filterField="email">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column header="Ações" style="width: 100px" v-if="can('seeEntities')">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-sm p-button-text"
              @click="updateEntity(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <EntityForm
      :visible.sync="formVisible"
      :data="formData"
      @cancel="closeForm"
      @created="createdEntity"
      @updated="updatedEntity"
    />
  </div>
</template>

<script>
import EntitiesService from "@/services/entities.service";
import { FilterMatchMode } from "primevue/api";
import EntityForm from "@/components/entity/EntityForm.vue";

export default {
  name: "EntityList",
  components: { EntityForm },
  data() {
    return {
      loading: false,
      entities: [],
      totalRecords: 0,
      currentPage: 1,
      perPage: 50,
      formVisible: false,
      formData: {},
      filters: {
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        address: { value: null, matchMode: FilterMatchMode.CONTAINS },
        zip_code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        telephone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        tlmvl: { value: null, matchMode: FilterMatchMode.CONTAINS },
        email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        nif: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  async activated() {
    await this.fetchEntities();
  },
  async created() {
    await this.fetchEntities();
  },
  methods: {
    buildQueryParams(page = 1) {
      const params = new URLSearchParams();
      params.append('page', page);

      for (const [key, filter] of Object.entries(this.filters)) {
        if (filter.value !== null && filter.value !== '') {
          params.append(`filters[${key}]`, filter.value);
        }
      }

      return params;
    },
    async fetchEntities(event = {}) {
      try {
        this.loading = true;

        const page = event.page ? event.page + 1 : 1;
        const params = this.buildQueryParams(page);
        params.append('per_page', event.rows || this.perPage);

        const response = await EntitiesService.index(params);

        if (response) {
          this.entities = response.data;
          this.totalRecords = response.meta.total;
          this.currentPage = response.meta.current_page;
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar entidades',
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    emptyFormData() {
      return (this.formData = {
        id: null,
      });
    },
    closeForm() {
      this.formVisible = false;
      return this.emptyFormData();
    },
    createEntity() {
      this.emptyFormData();
      return (this.formVisible = true);
    },
    createdEntity() {
      this.fetchEntities();
      return this.closeForm();
    },
    updateEntity(entity) {
      this.formData = { ...entity };
      return (this.formVisible = true);
    },
    updatedEntity() {
      this.fetchEntities({ page: this.currentPage - 1, rows: this.perPage });
      return this.closeForm();
    },
  },
};
</script>
